import { useEffect, useState } from "react";
import { api, fmtPrice } from "../../lib/api";
import { useBusiness } from "../../context/BusinessContext";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  const { business } = useBusiness();

  useEffect(() => {
    api.get("/stats").then((r) => setStats(r.data));
  }, []);

  const cards = [
    { label: "Revenue", value: stats ? fmtPrice(stats.revenue, business.currency) : "—", testId: "stat-revenue" },
    { label: "Total orders", value: stats?.total_orders ?? "—", testId: "stat-orders" },
    { label: "Paid", value: stats?.paid_orders ?? "—", testId: "stat-paid" },
    { label: "Pending", value: stats?.pending_orders ?? "—", testId: "stat-pending" },
    { label: "Products", value: stats?.total_products ?? "—", testId: "stat-products" },
    { label: "Categories", value: stats?.total_categories ?? "—", testId: "stat-categories" },
  ];

  return (
    <div data-testid="admin-dashboard-page">
      <div className="text-xs uppercase tracking-ultra text-neutral-500">Overview</div>
      <h1 className="text-4xl md:text-5xl font-black tracking-tighter leading-none mt-2">
        Dashboard
      </h1>
      <div className="mt-10 grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {cards.map((c) => (
          <div key={c.label} className="bg-white border border-black/10 p-6" data-testid={c.testId}>
            <div className="text-[10px] uppercase tracking-ultra text-neutral-500">{c.label}</div>
            <div className="mt-2 text-4xl font-black tracking-tighter">{c.value}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
